export default __webpack_public_path__ + "static/media/07_legen.6298fa80.svg";